import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function TurnstileSystemsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = "Turnike Sistemleri Kurulumu İstanbul | Tripod Kanatlı Tam Boy Turnike";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel turnike sistemleri kurulumu. Tripod, kanatlı ve tam boy turnike sistemleri ile personel giriş-çıkış kontrolü ve güvenlik yönetimi.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel turnike sistemleri kurulumu. Tripod, kanatlı ve tam boy turnike sistemleri ile personel giriş-çıkış kontrolü ve güvenlik yönetimi.';
      document.head.appendChild(meta);
    }

    // Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'turnike sistemi, tripod turnike, kanatlı turnike, tam boy turnike, personel giriş kontrol, PDKS turnike');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'turnike sistemi, tripod turnike, kanatlı turnike, tam boy turnike, personel giriş kontrol, PDKS turnike';
      document.head.appendChild(meta);
    }

    // Open Graph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Turnike Sistemleri Kurulumu İstanbul | Tripod Kanatlı Tam Boy Turnike');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Turnike Sistemleri Kurulumu İstanbul | Tripod Kanatlı Tam Boy Turnike';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fabrika ve sanayi tesisleri için güvenli turnike çözümleri. Biyometrik entegrasyon, personel takibi ve tek kişi geçiş kontrolü.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fabrika ve sanayi tesisleri için güvenli turnike çözümleri. Biyometrik entegrasyon, personel takibi ve tek kişi geçiş kontrolü.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/guvenlik-sistemleri/turnike-sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/guvenlik-sistemleri/turnike-sistemleri';
      document.head.appendChild(meta);
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/guvenlik-sistemleri/turnike-sistemleri');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/guvenlik-sistemleri/turnike-sistemleri';
      document.head.appendChild(link);
    }

    // Cleanup function
    return () => {
      document.title = 'Fiber Optik Ustası';
    };
  }, []);

  const features = [
    { icon: 'ri-user-line', title: 'Tek Kişi Geçiş', description: 'Bir seferde tek kişi geçiş kontrolü' },
    { icon: 'ri-speed-line', title: 'Hızlı Geçiş', description: 'Saniyeler içinde geçiş' },
    { icon: 'ri-fingerprint-line', title: 'Biyometrik Entegrasyon', description: 'Parmak izi ve yüz tanıma' },
    { icon: 'ri-shield-check-line', title: 'Güvenlik Sensörleri', description: 'Yetkisiz geçiş algılama' },
    { icon: 'ri-time-line', title: 'Zaman Takibi', description: 'Personel giriş-çıkış kayıtları' },
    { icon: 'ri-arrow-left-right-line', title: 'Çift Yönlü Geçiş', description: 'Giriş ve çıkış kontrolü' }
  ];

  const turnstileTypes = [
    {
      title: 'Tripod Turnike Sistemleri',
      description: 'En yaygın kullanılan turnike türü. Üç kollu döner mekanizma ile tek kişi geçiş kontrolü sağlar. Ekonomik ve güvenilir çözüm.',
      specs: ['3 kollu mekanizma', 'Paslanmaz çelik', 'Çift yönlü geçiş', 'Acil açılma'],
      image: 'https://public.readdy.ai/ai/img_res/07940bdd77713de5104e923b9ede611a.jpg'
    },
    {
      title: 'Kanatlı Turnike Sistemleri',
      description: 'Cam veya paslanmaz çelik kanatlar ile estetik ve modern görünüm. Ofis ve kurumsal işletmelerde tercih edilir.',
      specs: ['Cam/çelik kanatlar', 'Sessiz çalışma', 'Hızlı geçiş', 'Şık tasarım'],
      image: 'https://readdy.ai/api/search-image?query=modern%20glass%20wing%20turnstile%20gate%20elegant%20flap%20barrier%20with%20transparent%20panels%20office%20building%20entrance%20security%20turnstile%20with%20LED%20indicators%20clean%20white%20background%20product%20photography%20premium%20access%20control%20system&width=600&height=400&seq=sec011&orientation=landscape'
    },
    {
      title: 'Tam Boy Turnike Sistemleri',
      description: 'Yerden tavana kadar uzanan yüksek güvenlikli turnike. Fabrika ve sanayi tesislerinde maksimum güvenlik sağlar.',
      specs: ['Tam boy koruma', 'Yüksek güvenlik', 'Aşma önleme', 'Dayanıklı yapı'],
      image: 'https://readdy.ai/api/search-image?query=full%20height%20turnstile%20gate%20floor%20to%20ceiling%20security%20barrier%20industrial%20high%20security%20rotating%20turnstile%20with%20metal%20bars%20clean%20white%20background%20product%20photography%20maximum%20security%20entrance%20control&width=600&height=400&seq=sec012&orientation=landscape'
    }
  ];

  const faqs = [
    {
      question: 'Turnike sistemleri nasıl çalışır?',
      answer: 'Turnike sistemleri, mekanik veya elektro-mekanik döner mekanizma ile tek kişi geçiş kontrolü sağlar. Kullanıcı, kart okuyucu, biyometrik cihaz veya QR kod okuyucu ile kimliğini doğrular. Sistem yetki kontrolü yapar ve yetkili ise turnike kolları serbest bırakılır. Kullanıcı geçtikten sonra kollar otomatik olarak kilitlenir. Sensörler, aynı anda birden fazla kişinin geçmesini engeller ve yetkisiz geçiş girişimlerinde alarm verir.'
    },
    {
      question: 'Hangi turnike türünü seçmeliyim?',
      answer: 'Turnike seçimi, kullanım alanına ve güvenlik ihtiyacına göre yapılır. Tripod turnikeler, ekonomik ve yaygın kullanımlı çözümdür, fabrika ve sanayi tesislerinde tercih edilir. Kanatlı turnikeler, estetik görünüm gerektiren ofis ve kurumsal işletmelerde kullanılır. Tam boy turnikeler, maksimum güvenlik gerektiren alanlarda (askeri tesisler, kritik altyapılar) tercih edilir. Profesyonel keşif sonrası en uygun turnike türü önerilir.'
    },
    {
      question: 'Turnike sistemi kurulumu ne kadar sürer?',
      answer: 'Tek turnike kurulumu genellikle 4-6 saat sürer. Kurulum, zemin hazırlığı, turnike montajı, elektrik bağlantısı, kart okuyucu veya biyometrik cihaz entegrasyonu ve test işlemlerini içerir. Çift yönlü geçiş için iki turnike kurulumu 1 gün sürer. Çoklu turnike kurulumlarında (4+ turnike) 2-3 gün gerekebilir. Kurulum sonrası personel eğitimi verilir ve sistem testleri yapılır.'
    },
    {
      question: 'Acil durumlarda turnike açılır mı?',
      answer: 'Evet, tüm turnike sistemleri acil durum açılma özelliğine sahiptir. Yangın alarm sistemi ile entegrasyon yapılarak, yangın durumunda turnikeler otomatik olarak serbest bırakılır ve kollar serbestçe dönebilir hale gelir. Manuel açma butonu ile de turnikeler acil durumda açılabilir. Tripod ve kanatlı turnikelerde kollar tamamen açılır, tam boy turnikelerde kapı mekanizması devreye girer. Bu özellik, can güvenliği için kritik öneme sahiptir.'
    },
    {
      question: 'Turnike sistemleri personel takibi için kullanılabilir mi?',
      answer: 'Evet, turnike sistemleri personel devam takip sistemi (PDKS) olarak kullanılır. Her personelin giriş-çıkış saatleri otomatik olarak kaydedilir ve mesai süreleri hesaplanır. Geç kalma, erken çıkış ve fazla mesai raporlanır. Vardiya takibi yapılır ve departman bazlı raporlar alınabilir. Sistem, bordro yazılımları ile entegre çalışabilir. Fabrika ve sanayi tesislerinde üretim verimliliği analizi için de kullanılabilir.'
    },
    {
      question: 'Hangi bölgelerde turnike sistemleri kurulumu yapıyorsunuz?',
      answer: 'İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Ataşehir, Kadıköy, Ümraniye, Esenyurt, Başakşehir, Pendik, Kartal, Beylikdüzü, Tuzla, Gebze, Dilovası, Çayırova, Kocaeli, Sakarya, Yalova, Bursa, Tekirdağ ve Çorlu bölgelerinde turnike sistemleri kurulumu hizmeti veriyoruz. Fabrika, sanayi tesisi, OSB ve kurumsal işletmelere profesyonel turnike çözümleri sunuyoruz.'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20turnstile%20gates%20at%20industrial%20facility%20entrance%20professional%20pedestrian%20access%20control%20system%20security%20turnstiles%20with%20card%20readers%20factory%20entrance%20with%20multiple%20turnstile%20barriers%20gray%20ambient%20lighting%20dark%20background%20industrial%20security%20checkpoint&width=1920&height=800&seq=sec013&orientation=landscape"
            alt="Turnike Sistemleri"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/85 to-slate-950"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-gray-400 transition-colors cursor-pointer">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/guvenlik-sistemleri" className="hover:text-gray-400 transition-colors cursor-pointer">Güvenlik Sistemleri</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-400">Turnike Sistemleri</span>
          </nav>

          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-600/20 border border-gray-500/30 rounded-full mb-6">
              <i className="ri-login-box-line text-gray-400 text-lg"></i>
              <span className="text-gray-300 text-sm font-medium">Profesyonel Turnike Sistemleri</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Turnike Sistemleri Kurulumu
            </h1>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde fabrika, sanayi tesisi ve kurumsal işletmeler için profesyonel turnike sistemleri kurulumu. Tripod, kanatlı ve tam boy turnike sistemleri ile personel giriş-çıkış kontrolü ve güvenlik yönetimi.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-gray-700 to-gray-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-gray-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp Destek
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <article className="prose prose-invert prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-white mb-6">Turnike Sistemleri Nedir?</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Turnike sistemleri, yaya geçişlerini kontrol eden ve tek kişi geçiş sağlayan mekanik veya elektro-mekanik güvenlik cihazlarıdır. Fabrika girişleri, sanayi tesisi, ofis binası ve kurumsal işletme girişlerinde kullanılarak, sadece yetkili personelin girmesine izin verir. Döner kol mekanizması ile bir seferde sadece bir kişinin geçmesini sağlar ve yetkisiz geçiş girişimlerini engeller.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Modern turnike sistemleri, kart okuyucu, biyometrik cihaz, QR kod okuyucu ve yüz tanıma sistemi ile entegre çalışır. Her geçiş kaydedilir ve personel devam takip sistemi (PDKS) olarak kullanılır. İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde profesyonel turnike sistemleri kurulumu hizmeti veriyoruz. Tripod, kanatlı ve tam boy turnike seçenekleri ile her ihtiyaca uygun çözümler sunuyoruz.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Turnike Sistemlerinin Özellikleri</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 not-prose">
                {features.map((feature, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-gray-500/50 transition-all duration-300">
                    <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-lg mb-4">
                      <i className={`${feature.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Turnike Türleri ve Özellikleri</h2>
              <div className="space-y-8 mb-8 not-prose">
                {turnstileTypes.map((turnstile, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl overflow-hidden hover:border-gray-500/50 transition-all duration-300">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="w-full h-64">
                        <img
                          src={turnstile.image}
                          alt={turnstile.title}
                          className="w-full h-full object-cover object-center"
                        />
                      </div>
                      <div className="p-6 flex flex-col justify-center">
                        <h3 className="text-2xl font-bold text-white mb-4">{turnstile.title}</h3>
                        <p className="text-gray-300 leading-relaxed mb-4">{turnstile.description}</p>
                        <div className="flex flex-wrap gap-3">
                          {turnstile.specs.map((spec, idx) => (
                            <span key={idx} className="px-3 py-1 bg-gray-600/20 border border-gray-500/30 rounded-full text-gray-300 text-sm">
                              {spec}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Turnike Sistemi Kurulum Süreci</h2>
              <div className="space-y-6 mb-8 not-prose">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-full text-white font-bold">1</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Keşif ve Planlama</h3>
                    <p className="text-gray-300">Kurulum alanı incelenir, geçiş noktaları belirlenir. Personel sayısı ve geçiş yoğunluğu analiz edilir.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-full text-white font-bold">2</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Turnike Seçimi</h3>
                    <p className="text-gray-300">Güvenlik ihtiyacına ve estetik beklentiye göre uygun turnike türü seçilir. Kart okuyucu veya biyometrik entegrasyon planlanır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-full text-white font-bold">3</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Zemin Hazırlığı</h3>
                    <p className="text-gray-300">Turnike temeli için zemin hazırlanır, gerekirse beton dökülerek sağlam zemin oluşturulur. Elektrik kablo kanalları hazırlanır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-full text-white font-bold">4</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Montaj ve Entegrasyon</h3>
                    <p className="text-gray-300">Turnike gövdesi monte edilir, kart okuyucu veya biyometrik cihaz entegre edilir. Elektrik bağlantıları yapılır, kontrol paneli kurulur.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-full text-white font-bold">5</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Test ve Eğitim</h3>
                    <p className="text-gray-300">Turnike mekanizması test edilir, sensörler kalibre edilir. Personele sistem kullanımı ve acil durum prosedürleri hakkında eğitim verilir.</p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Biyometrik Entegrasyon</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Turnike sistemleri, biyometrik kimlik doğrulama cihazları ile entegre çalışarak yüksek güvenlik sağlar. Parmak izi okuyucu, yüz tanıma sistemi veya iris tanıma cihazları turnike üzerine monte edilir. Kullanıcı, biyometrik kimliğini doğruladıktan sonra turnike serbest bırakılır. Bu sistem, kart kaybı veya şifre unutma riskini ortadan kaldırır ve kimlik hırsızlığını engeller.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Hibrit sistemler de kullanılabilir. Örneğin, kart + parmak izi kombinasyonu ile çift faktörlü doğrulama yapılır. Bu yöntem, maksimum güvenlik gerektiren alanlarda tercih edilir. Fabrika ve sanayi tesislerinde, üretim alanlarına giriş için biyometrik turnike sistemleri yaygın olarak kullanılır. Sistem, her geçişte fotoğraf çekerek kayıt altına alabilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Personel Devam Takip Sistemi (PDKS)</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Turnike sistemleri, personel devam takip sistemi olarak kullanılır. Her personelin giriş-çıkış saatleri otomatik olarak kaydedilir ve veritabanında saklanır. Mesai süreleri, geç kalma, erken çıkış ve fazla mesai otomatik olarak hesaplanır. Vardiya takibi yapılır ve vardiya değişim saatlerinde otomatik raporlar oluşturulur.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Sistem, bordro yazılımları ile entegre çalışarak ücret hesaplamalarında kullanılır. Departman bazlı raporlar, kişi bazlı detaylı kayıtlar ve özet raporlar alınabilir. Yöneticiler, mobil uygulama üzerinden anlık personel durumunu görebilir. İzin, rapor ve resmi tatil günleri sisteme tanımlanarak doğru hesaplama yapılır. Fabrika ve sanayi tesislerinde üretim verimliliği analizi için kritik veri sağlar.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Ziyaretçi Yönetimi</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Turnike sistemleri, ziyaretçi yönetimi için de kullanılır. Ziyaretçiler için geçici kartlar veya QR kodlar oluşturulur. Resepsiyon yazılımı ile entegre çalışarak, ziyaretçi kaydı hızlı ve kolay yapılır. Ziyaretçinin fotoğrafı çekilir, kimlik bilgileri kaydedilir ve ziyaret edilen kişi belirlenir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Ziyaretçi kartları, belirli alanlara ve belirli zaman dilimlerine sınırlandırılabilir. Ziyaret süresi dolduğunda sistem uyarı verir. Çıkışta ziyaretçi kartı iade edilir ve ziyaret süresi kaydedilir. Fabrika ve sanayi tesislerinde güvenlik için kritik öneme sahiptir. Tüm ziyaretçi hareketleri raporlanabilir ve denetlenebilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Acil Durum ve Güvenlik Özellikleri</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Turnike sistemleri, acil durum güvenliği için özel özellikler içerir. Yangın alarm sistemi ile entegrasyon yapılarak, yangın durumunda turnikeler otomatik olarak serbest bırakılır. Tripod ve kanatlı turnikelerde kollar tamamen açılır, tam boy turnikelerde kapı mekanizması devreye girer. Bu özellik, can güvenliği için kritik öneme sahiptir ve yönetmelik gereğidir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Manuel açma butonu ile de turnikeler acil durumda açılabilir. Güvenlik personeli, kontrol panelinden tüm turnikeleri aynı anda açabilir. Elektrik kesintisinde yedek pil ile sistem çalışmaya devam eder. Yetkisiz geçiş girişimlerinde sesli ve ışıklı uyarı verilir. Anti-panik özelliği ile, yoğun tahliye durumlarında turnikeler otomatik olarak serbest kalır.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bakım ve Servis Hizmetleri</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Turnike sistemleri, düzenli bakım ile uzun ömürlü ve güvenilir çalışır. Yılda en az 2 kez periyodik bakım yapılmalıdır. Bakımda döner mekanizma yağlaması, sensör kalibrasyonu, elektrik bağlantıları kontrolü ve yazılım güncellemesi yapılır. Kart okuyucular ve biyometrik cihazlar temizlenir ve test edilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Arızalı motor değişimi, kol tamiri, sensör değişimi ve kontrol paneli onarımı hizmetleri sunuyoruz. 7/24 teknik destek hattımız ile her türlü sorun anında çözülür. İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Tuzla, Gebze, Kocaeli, Bursa ve diğer bölgelerde hızlı servis hizmeti veriyoruz. Acil durumlarda aynı gün müdahale garantisi sağlıyoruz. Tüm kurulumlarımız 2 yıl garanti kapsamındadır.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-white text-center mb-12">
              Sıkça Sorulan Sorular
            </h2>

            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden hover:border-gray-500/50 transition-all duration-300">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-xl font-bold text-white pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-2xl text-gray-400 group-open:rotate-180 transition-transform duration-300"></i>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-white text-center mb-12">
              Diğer Güvenlik Sistemleri Hizmetlerimiz
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link to="/guvenlik-sistemleri/bariyer-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-slate-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-roadster-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-slate-400 transition-colors">Bariyer Sistemleri</h3>
                <p className="text-gray-400 text-sm">Otomatik bariyer kurulumu ve bakımı</p>
              </Link>

              <Link to="/guvenlik-sistemleri/gecis-kontrol-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-door-lock-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors">Geçiş Kontrol Sistemleri</h3>
                <p className="text-gray-400 text-sm">Kartlı ve biyometrik geçiş sistemleri</p>
              </Link>

              <Link to="/guvenlik-sistemleri/ip-kamera-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-camera-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">IP Kamera Sistemleri</h3>
                <p className="text-gray-400 text-sm">4K Ultra HD kamera kurulumu</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-700/20 to-gray-600/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Turnike Sistemi Kurulumu İçin Hemen İletişime Geçin
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Ücretsiz keşif ve teknik danışmanlık için bizi arayın. Profesyonel ekibimiz size en uygun çözümü sunar.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-gray-700 to-gray-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-gray-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                +90 553 716 55 61
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </div>
  );
}